
<div id="footer-cookies">
    <p>Este sitio web utiliza cookies propias para mejorar la experiencia de navegación y el funcionamiento del sitio. Al continuar navegando, aceptas su uso.</p>
    <div>
        <button class="aceptar" (click)="aceptarCookies()">Aceptar</button>
    </div>
</div>
